import React from "react";
import { getFileExtension } from "../../../../utils/docHelper";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var getIcon = function getIcon(type) {
  switch (type) {
    case "jpeg":
    case "jpg":
    case "png":
      return renderImageIcon();
    case "docx":
    case "doc":
    case "xml":
      return renderDocxIcon();
    case "pdf":
      return renderPdfIcon();
    case "csv":
    case "xlsx":
    case "xlsm":
      return renderExcelIcon();
    default:
      return renderPdfIcon();
  }
};
var renderPdfIcon = function renderPdfIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-1009 -689)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M5,0H35a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
        transform: "translate(1009 689)",
        fill: "#d24f3e"
      }), /*#__PURE__*/_jsx("text", {
        transform: "translate(1029 715)",
        fill: "#fff",
        fontSize: "14",
        fontFamily: "SegoeUI, Segoe UI",
        children: /*#__PURE__*/_jsx("tspan", {
          x: "-12.247",
          y: "0",
          children: "PDF"
        })
      })]
    })
  });
};
var renderDocxIcon = function renderDocxIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-1009 -689)",
      children: [/*#__PURE__*/_jsx("g", {
        transform: "translate(1009 689)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M5,0H35a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
          fill: "#4d78eb"
        })
      }), /*#__PURE__*/_jsx("text", {
        transform: "translate(1029 715)",
        fill: "#fff",
        fontSize: "14",
        fontFamily: "SegoeUI, Segoe UI",
        children: /*#__PURE__*/_jsx("tspan", {
          x: "-14.52",
          y: "0",
          children: "DOC"
        })
      })]
    })
  });
};
var renderExcelIcon = function renderExcelIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-1009 -689)",
      children: [/*#__PURE__*/_jsx("g", {
        transform: "translate(1009 689)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M5,0H35a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
          fill: "#14897b"
        })
      }), /*#__PURE__*/_jsx("text", {
        transform: "translate(1029 715)",
        fill: "#fff",
        fontSize: "14",
        fontFamily: "SegoeUI, Segoe UI",
        children: /*#__PURE__*/_jsx("tspan", {
          x: "-11.143",
          y: "0",
          children: "XLS"
        })
      })]
    })
  });
};
var renderImageIcon = function renderImageIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-1009 -689)",
      children: [/*#__PURE__*/_jsx("g", {
        transform: "translate(1009 689)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M5,0H35a5,5,0,0,1,5,5V35a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
          fill: "#4652a4"
        })
      }), /*#__PURE__*/_jsx("text", {
        transform: "translate(1029 715)",
        fill: "#fff",
        fontSize: "14",
        fontFamily: "SegoeUI, Segoe UI",
        children: /*#__PURE__*/_jsx("tspan", {
          x: "-11.221",
          y: "0",
          children: "JPG"
        })
      })]
    })
  });
};
function ProjectDocs(_ref) {
  var documents = _ref.documents,
    config = _ref.config;
  var isImage = ["jpeg", "jpg", "png"];
  var displayType = function displayType(src) {
    var fileType = getFileExtension(src);
    if (isImage.includes(fileType)) {
      return /*#__PURE__*/_jsx("img", {
        className: "h-[200px] rounded-xl",
        src: src
      });
    } else {
      return /*#__PURE__*/_jsxs("div", {
        className: "relative w-full h-[200px]",
        children: [/*#__PURE__*/_jsx("div", {
          className: "absolute inset-0 z-20"
        }), /*#__PURE__*/_jsx("iframe", {
          src: "".concat(src, "#view=FitV&page=1&scrollbar=0&toolbar=0&statusbar=0&messages=0&navpanes=0"),
          width: "100%",
          height: "100%",
          title: "PDF Preview"
        })]
      });
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: " mt-8 flex flex-col",
    children: [/*#__PURE__*/_jsx("h4", {
      className: "z-10 text-xl ".concat(config !== null && config !== void 0 && config.darkMode ? "text-primary" : "text-[#130E2F]", " my-2 font-bold ").concat(config.fontTitle),
      children: "Documents"
    }), /*#__PURE__*/_jsx("div", {
      className: "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5",
      children: documents === null || documents === void 0 ? void 0 : documents.map(function (doc, idx) {
        var _doc$type;
        return /*#__PURE__*/_jsxs("div", {
          onClick: function onClick() {
            return window.open(doc.link || doc.name, "_blank");
          },
          className: " ".concat(config.fontBody, " z-10 bg-gray-200 p-4 rounded-xl cursor-pointer "),
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex items-center mb-2",
            children: [getIcon(getFileExtension(doc !== null && doc !== void 0 && doc.link ? doc === null || doc === void 0 ? void 0 : doc.link : doc === null || doc === void 0 ? void 0 : doc.name)), /*#__PURE__*/_jsx("h1", {
              className: "font-semibold ml-2  xl:text-[15px] 2xl:text-[16px]",
              children: (_doc$type = doc.type) === null || _doc$type === void 0 ? void 0 : _doc$type.replace(/_/g, " ")
            })]
          }), /*#__PURE__*/_jsx("div", {
            children: displayType(doc !== null && doc !== void 0 && doc.link ? doc === null || doc === void 0 ? void 0 : doc.link : doc === null || doc === void 0 ? void 0 : doc.name)
          })]
        }, ((doc === null || doc === void 0 ? void 0 : doc.link) || (doc === null || doc === void 0 ? void 0 : doc.name) || "doc") + idx);
      })
    })]
  });
}
export default ProjectDocs;